module.exports = __webpack_public_path__ + "img/agent_invitef.dd998212.jpg";